import axios from 'axios';

import apiConstants from './constants/api-constants';
import Helpers from '../common/helpers';

class UserProfileApi {
  static getUserProfile(token, xsrf) {
    const headers = token && xsrf ? {
      'x-token': token,
      'x-xsrf-token': xsrf,
    } : null;

    const request = Helpers.formAxiosObject(apiConstants.request_methods.get, apiConstants.user_profile_routes.get_user_profile, null, null, null, headers);

    return axios(request);
  }

  static editUserProfile(data) {
    const request = Helpers.formAxiosObject(apiConstants.request_methods.post, apiConstants.user_profile_routes.edit_user_profile, data);

    return axios(request);
  }
}

export default UserProfileApi;



// WEBPACK FOOTER //
// ./src/api/user-profile-api.js